export const Constants: any = {
    SALES_CONDITIONS: {
        "it-IT": "https://saviospa.com/public/savio/PDF/2024_CONDIZIONI-DI-VENDITA-ITA_Internet.pdf",
        "en-US": "https://saviospa.com/public/savio/PDF/2024_CONDIZIONI-DI-VENDITA-EN.pdf",
        "zh-CN": "https://saviospa.com/public/savio/PDF/2024_CONDIZIONI-DI-VENDITA-EN.pdf",
        "fr-FR": "https://saviospa.com/public/savio/PDF/2024_CONDIZIONI-DI-VENDITA-FR.pdf",
        "es-ES": "https://saviospa.com/public/savio/PDF/2024_CONDIZIONI-DI-VENDITA-SP.pdf",
        "tr-TR": "https://saviospa.com/public/savio/PDF/2024_CONDIZIONI-DI-VENDITA-EN.pdf"

    }
}